import { render, staticRenderFns } from "./AddTaxCoin.vue?vue&type=template&id=00d8e5a8&"
import script from "./AddTaxCoin.vue?vue&type=script&lang=ts&"
export * from "./AddTaxCoin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports